export function sample<T>(input: T[] | { [key: string]: T }): T {
  if (Array.isArray(input)) {
    const randomIndex = Math.floor(Math.random() * input.length);
    return input[randomIndex];
  } else {
    const keys = Object.keys(input);
    const randomIndex = Math.floor(Math.random() * keys.length);
    const randomKey = keys[randomIndex];
    return input[randomKey];
  }
}
